import { useState, useMemo, useEffect } from "react";
import "./ProductivityFeedback.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useConstants } from "../../constant/constantProvider";
import { updateProductivityFeedbackRequest } from "../../store/apiActions";
import { useDispatch } from "react-redux";
import Modal from "../Modal/Modal";

const ProductivityFeedbackPopup = ({ onClose }) => {
  const [percentage, setPercentage] = useState(50);
  const [comment, setComment] = useState("");
  const { 
    FEEDBACK_TITLE, FEEDBACK_DESCRIPTION, PERCENTAGE_LABEL, 
    FEEDBACK_COMMENT_PROMPT, FEEDBACK_SUBMIT, FEEDBACK_CANCEL,
    FEEDBACK_SUBMIT_SUCCESS, FEEDBACK_SUBMIT_FAILED
  } = useConstants();
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.classList.add("feedback-open");
    return () => {
      document.body.classList.remove("feedback-open");
    };
  }, []);

  // Dynamic slider background
  const sliderBackground = useMemo(() => {
    return `linear-gradient(to right, var(--primary-blue) 0%, 
      var(--primary-blue) ${percentage}%, 
      rgba(37, 99, 235, 0.15) ${percentage}%, 
      rgba(37, 99, 235, 0.15) 100%)`;
  }, [percentage]);

  const handleSubmit = async (dismissed = false) => {
    try {
      if (!dismissed && !percentage) {
        toast.error("Please select a productivity percentage");
        return;
      }

      const payload = {
        productivity_score: percentage,
        comment: comment.trim(),
        dismissed,
      };

      onClose();

      const response = await dispatch(
        updateProductivityFeedbackRequest(payload)
      );

      if (!dismissed) {
        if (response?.status === "success") {
          toast.info(FEEDBACK_SUBMIT_SUCCESS || "Feedback submitted successfully");
        } else {
          toast.error(FEEDBACK_SUBMIT_FAILED || "Failed to submit feedback");
        }
      }

    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error(FEEDBACK_SUBMIT_FAILED || "Error submitting feedback");
    }
  };

  const handleCancel = async () => {
    await handleSubmit(true); // dismissed = true
  };

  const handleSubmitClick = async () => {
    await handleSubmit(false); // dismissed = false
  };

  return (
    <Modal open={true}>
      <div className="feedback-popup">
        <div className="give-feedback">{FEEDBACK_TITLE}</div>
        <div className="feedback-text">{FEEDBACK_DESCRIPTION}</div>
        <div className="productivity-section">
          <div className="percentage-label">
            {PERCENTAGE_LABEL}: <strong>{percentage}%</strong>
          </div>

          <input
            type="range"
            min="0"
            max="100"
            value={percentage}
            onChange={(e) => setPercentage(Number(e.target.value))}
            style={{ background: sliderBackground }}
            className="percentage-slider"
          />

          <div className="range-labels">
            <span>0%</span>
            <span>25%</span>
            <span>50%</span>
            <span>75%</span>
            <span>100%</span>
          </div>
        </div>

        <textarea
          placeholder={FEEDBACK_COMMENT_PROMPT}
          className="feedback-textarea"
          value={comment}
          maxLength={1000}
          onChange={(e) => setComment(e.target.value)}
        />

        <div className="button-section">
          <button
            onClick={handleCancel}
            className="button-style primary-grey-button"
          >
            {FEEDBACK_CANCEL}
          </button>

          <button
            className="button-style primary-button"
            onClick={handleSubmitClick}
          >
            {FEEDBACK_SUBMIT}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ProductivityFeedbackPopup;